import React from 'react';
import { OLFullScreenView } from './OLFullScreenView';
import { PLFullScreenView } from './PLFullScreenView';
import { ZSFullScreenView } from './ZSFullScreenView';
import { WRFullScreenView } from './WRFullScreenView';

export const FullScreenBase = ({ module, updateOrders, refFormik, closeByESCKey }) => {
  React.useEffect(() => {
    document.addEventListener('keyup', closeByESCKey, true);

    return () => {
      document.removeEventListener('keyup', closeByESCKey, true);
    };

  }, [closeByESCKey]);

  return (
    <>
      {
        module == 'obozy' ? <OLFullScreenView updateOrders={updateOrders} refFormik={refFormik} />
          : module == 'polkolonie' ? <PLFullScreenView updateOrders={updateOrders} refFormik={refFormik} />
            : module == 'zielone_szkoly' ? <ZSFullScreenView updateOrders={updateOrders} refFormik={refFormik} />
              : module == 'wyjazdy_rodzinne' ? <WRFullScreenView updateOrders={updateOrders} refFormik={refFormik} /> : null
      }
    </>
  );
};
